import { render } from "./formgrouptextarea.vue?vue&type=template&id=05eb76fb"
import script from "./formgrouptextarea.vue?vue&type=script&lang=js"
export * from "./formgrouptextarea.vue?vue&type=script&lang=js"

import exportComponent from "/Users/adi/Sites/yelp-ads/sweepstakes-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__